import React, { Component, Fragment } from "react";
import { connect } from "react-redux";
import { setUserOrganizer, getOrganizersList, setEventOrganizer, getEventsUserList, deleteOrganizer } from "../../../store/actions/createEvents.actions";
import Message from "../../Common/Message";

const mapStateToProps = (state) => ({
    usersList: state.createEvent.eventUsers,
    selectedOrganizer: state.createEvent.selectedOrganizer,
    newEventID: state.createEvent.newEventID,
    organizerList: state.createEvent.organizerList
});

const mapDispatchToProps = (dispatch: any) => ({
    getEventsUserList: (data) => (dispatch(getEventsUserList(data))),
    setUserOrganizer: (data) => (dispatch(setUserOrganizer(data))),
    getOrganizersList: (id) => (dispatch(getOrganizersList(id))),
    setEventOrganizer: (data) => (dispatch(setEventOrganizer(data))),
    deleteOrganizer: (data) => (dispatch(deleteOrganizer(data)))
});

class AddOrganizer extends Component<Props, State> {
    constructor(props) {
        super(props);

        this.state = {
            searchTerm: "",
            showDropdown: false,
            addOrganizerError: false
        };

        this.handleChange = this.handleChange.bind(this);
    }

    componentDidMount = () => {
        const { getEventsUserList, getOrganizersList, newEventID } = this.props;
        const data = {
            eventId: newEventID,
            isOrganizer: true
        };
        getEventsUserList(data);
        getOrganizersList(newEventID);
    };

    handleChange(event) {
        const value = event.target.value;
        this.setState({
            [event.target.name]: value,
            showDropdown: true,
            addOrganizerError: false
        });
    };

    handleSelect = (user) => {
        const { setUserOrganizer } = this.props;
        setUserOrganizer(user.id);
        this.setState({
            searchTerm: user.email,
            showDropdown: false,
            addOrganizerError: false
        });
    };

    handleAddOrganizer = () => {
        const { setEventOrganizer, selectedOrganizer, newEventID, setUserOrganizer } = this.props;
        if (selectedOrganizer === null) {
            this.setState({
                addOrganizerError: true
            })
        }
        else {
            const data = {
                eventId: newEventID,
                userId: selectedOrganizer && selectedOrganizer
            };
            setEventOrganizer(data);
            this.setState({
                searchTerm: ""
            });
            setUserOrganizer(null);
        }
    };

    handleDeleteOrganizer = (id) => {
        const { newEventID, deleteOrganizer } = this.props;
        const data = {
            eventId: newEventID,
            userId: id
        };
        deleteOrganizer(data);
    };

    render() {
        const { usersList, organizerList } = this.props;
        const { searchTerm, showDropdown, addOrganizerError } = this.state;


        return (
            <>
                {addOrganizerError && (
                    <Message
                        type="danger"
                        defaultMessage={"Please Select a User to add"}
                        baseClassName="alert"
                    ></Message>
                )}
                <div className="form-row">
                    <span className="mt-2">Search: &nbsp; </span>{/* <em className="fa fa-search"></em> */}
                    <input className="mr-5"
                        style={{ borderColor: "lightgray", borderWidth: "1px", width: "300px" }}
                        placeholder="&nbsp;&nbsp;Search User..."
                        value={searchTerm}
                        name="searchTerm"
                        autoComplete="off"
                        onChange={this.handleChange} />
                    <button className="btn btn-secondary" style={{ backgroundColor: "#00456c", color: "white" }} onClick={() => this.handleAddOrganizer()}>Add</button>
                </div><br />
                <div className="form-row">
                    {showDropdown && searchTerm && (
                        <ul
                            style={{
                                listStyle: "none",
                                margin: 0,
                                padding: "0.5rem",
                                border: "1px solid #ccc",
                                position: "relative",
                                width: "100%",
                                backgroundColor: "#fff",
                                zIndex: 1
                            }}
                        >
                            {usersList.length > 0 ? (
                                usersList &&
                                usersList
                                    .filter(user => user.email.toLowerCase().includes(searchTerm.toLowerCase())
                                    ).map(user => (
                                        <li
                                            key={user.id}
                                            onClick={() => this.handleSelect(user)}
                                            style={{
                                                padding: "0.3rem 0",
                                                cursor: "pointer"
                                            }}
                                        >
                                            <strong>{user.name}</strong> - {user.email}
                                        </li>
                                    ))
                            ) : (
                                <li style={{ color: "#999" }}>No match found</li>
                            )}
                        </ul>
                    )}
                </div>
                <div className="form-row">
                    {organizerList && organizerList.length > 0 ? (
                        <table className="table table-striped table-hover w-100 vw-table">
                            <thead>
                                <tr>
                                    <th className="text-center">
                                        <strong>Name</strong>
                                    </th>
                                    <th className="text-center">
                                        <strong>Email</strong>
                                    </th>
                                </tr></thead>
                            <tbody>
                                {organizerList
                                    .map((data) => (
                                        <tr key={data.id}>
                                            <td align="center">{data.name}</td>
                                            <td align="center">{data.email}</td>
                                            <td><button className="btn btn-sm btn-secondary ml-2" style={{ width: "35px" }} onClick={() => this.handleDeleteOrganizer(data.id)}>
                                                <em className="fa fa-trash mr-4"></em>
                                            </button></td></tr>))}
                            </tbody></table>) : <Fragment>
                        <div style={{ padding: "5px" }}>
                            <span>No records</span>
                        </div>
                    </Fragment>}</div></>
        );
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(AddOrganizer);